const PUBLISHABLE_KEY = "pk_test_5MqUfyDl8HQyi73WAQ967pGB00olvv3BsL"

const URL = "https://tours-booking.herokuapp.com" || "http://localhost:4000"

// const URL = "http://localhost:4000"

export {PUBLISHABLE_KEY, URL}